import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { NavDropdown } from "react-bootstrap";
import { FacebookShareButton, FacebookIcon, WhatsappShareButton, WhatsappIcon, TwitterShareButton, TwitterIcon } from 'react-share';
import Deadline from "./Deadline";
import config from '../../config';
import LocaleContext from '../../LocaleContext';
import i18n from '../../i18n';

var url = config.nav.url;

var admin_link = url+'admin';
var news_link = url+'news';
var dashboard_link=url+'dashboard';
var logout_link=url+'logout';

const Navbar = (props) => {
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    function changeLocale (l) {
        if (locale !== l) {
          i18n.changeLanguage(l);
        }
    }

    const type = localStorage.getItem('type');
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                        <a className="nav-link active" aria-current="page" href="https://www.irad.cm"><i className="fa fa-arrow-left me-2"></i>{t('goToIrad')}</a>
                        </li>
                    </ul>
                    <Deadline />
                    <NavLink className="navbar-brand fw-bolder fs-1 mx-auto" to={url}><img src="/assets/logo.png" alt="About" className="logo w-75 "/></NavLink>
                    {!props.auth?
                    <>
                    <FacebookShareButton
                        url={config.nav.full_url}
                        quotes={"Apafrep IRAD"}
                        hashtag="#Apafrep IRAD"
                    >
                        <FacebookIcon size={30} className='me-2'/>
                    </FacebookShareButton>
                    <TwitterShareButton
                        url={config.nav.full_url}
                        title={"Apafrep IRAD"}
                        hashtag="#Apafrep IRAD"
                    >
                        <TwitterIcon size={30} className='me-2'/>
                    </TwitterShareButton>
                    <WhatsappShareButton
                        url={config.nav.full_url}
                        title={"Apafrep IRAD"}
                        separator=":: "
                    >
                        <WhatsappIcon size={30} />
                    </WhatsappShareButton>
                    {
                        type === 'admin' || type === 'exam' ?
                        <NavLink to={admin_link} className="btn ms-2 px-4 rounded-pill">
                        <i className="fa fa-dashboard me-2"></i><strong>Administration</strong></NavLink>
                        : <></>
                    }
                    <NavLink to={news_link} className="btn ms-2 px-4 rounded-pill">
                        <i className="fa fa-newspaper-o me-2"></i><strong>Blog</strong></NavLink>
                    <NavLink to={dashboard_link} className="btn btn-outline-primary">
                        <i className="me-2"></i><strong>{t('login')}</strong></NavLink>
                        </>
                        :
                        <>
                    <NavLink to={dashboard_link} className="btn btn-primary ms-2 px-4 rounded-pill">
                        <i className="fa fa-user-plus me-2"></i>Dashboard</NavLink>
                    <NavLink to={logout_link} className="btn btn-outline-primary ms-2 px-4 rounded-pill">
                        <i className="fa fa-sign-out me-2"></i>Logout</NavLink>
                        </>
}
                        <NavDropdown className='strong-black' title={t('language')} id="basic-nav-dropdown">
                                <NavDropdown.Item href="#" onClick={() => changeLocale('fr')}>Français</NavDropdown.Item>
                                <NavDropdown.Item href="#" onClick={() => changeLocale('en')}>English</NavDropdown.Item>
                        </NavDropdown>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default Navbar;